import { buildStartEnd } from '@/lib/reservation.utils';
import { reservationsStore } from '@/routes';
import { ReservationForm } from '@/types';
import { router } from '@inertiajs/react';

interface Params {
    data: ReservationForm;
    onSuccess: () => void;
    onError: (message: string) => void;
}

export function submitReservation({ data, onSuccess, onError }: Params) {
    const { start, end } = buildStartEnd(
        data.date,
        data.start_time,
        data.end_time,
    );

    const payload = {
        name: data.name,
        phone: data.phone,
        guests: data.guests,
        reservable_type: data.reservable_type,
        reservable_id: data.reservable_id,
        start,
        end,
    };

    router.post(reservationsStore().url, payload, {
        onSuccess,
        onError: (error) => {
            onError(error.error ?? 'Something went wrong');
        },
    });
}
